import * as jsonld from 'jsonld';
import { _validateUriId, _checkCredentialStatus } from '../../helper';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const assertCredentialStatus = /* @__PURE__ */ __name((cs, mode = "verify") => {
  const { id, type } = cs;
  if (id) {
    _validateUriId({
      id,
      propertyName: "credentialStatus.id"
    });
  }
  if (!type) {
    throw new Error('"credentialStatus" must include a type.');
  }
  _checkCredentialStatus(cs, mode);
}, "assertCredentialStatus");
const assertCredentialStatuses = /* @__PURE__ */ __name((credential, mode = "verify") => {
  const cses = jsonld.getValues(credential, "credentialStatus");
  cses.forEach((cs) => assertCredentialStatus(cs, mode));
  if (cses.some((cs) => cs?.type === "TransferableRecords") && credential?.credentialStatus?.type !== "TransferableRecords") {
    throw new Error('"credentialStatus" TransferableRecords must be the only credential status and must be an object.');
  }
}, "assertCredentialStatuses");

export { assertCredentialStatus, assertCredentialStatuses };
